// 由 pb-proto 生成（手写模板）。线上文本帧 = Envelope<DeviceMessage | Command | ConsoleMessage | ServerMessage>
export type Envelope<T> = { v: number; seq?: number; ts: number } & T;
export const PROTOCOL_VERSION = 2;
